export const ADD_CONTACT_IN_STORE = 'ADD_CONTACT_IN_STORE';